(function(){
'use strict';
if(window.CPEnquiryAdapters)return;
const wired=new WeakSet();
function mountAfter(result){
 let mount=result.nextElementSibling;
 if(!mount?.hasAttribute('data-cp-enquiry-slot')){mount=document.createElement('div');mount.dataset.cpEnquirySlot='';mount.className='cp-enquiry-slot';result.after(mount);}
 return mount;
}
function wire(form,result,source,type,context,onlyIfHelp){
 if(!form||!result||wired.has(form))return;wired.add(form);
 let started=false;
 const start=()=>{if(!started)started=window.CPAnalytics?.track?.('cp_planner_started',{tool:source,context:context||'business'})===true;};
 form.addEventListener('input',start);form.addEventListener('change',start);form.addEventListener('submit',start);
  const site=form.matches('[data-cpb-site-check]');
 function invalidate(){
  const options={context:context||'business',clearCoverage:site};
  window.CPEnquiry?.invalidate(source,options);
  if(site)window.CPEnquiry?.invalidate('site-check',{context:context||'business'});
  if(form.closest('[data-cpb-install-tool]'))window.CPEnquiry?.invalidate('installation-check',{context:context||'business'});
 }
 form.addEventListener('input',invalidate);form.addEventListener('change',invalidate);
 form.addEventListener('submit',()=>{
  setTimeout(()=>{
   if(!form.isConnected||form.dataset.cpToolBlocked==='true'||result.hidden||!form.checkValidity()){window.CPEnquiry?.invalidate(source);return;}
   if(onlyIfHelp&&!result.querySelector('a[href*="/contact"]')&&!result.querySelector('.cp-b2cx__no-match')){window.CPEnquiry?.invalidate(source);return;}
   const info=window.CPEnquiry;if(!info)return;
   const postcode=form.querySelector('[data-cpb-postcode]')||form.elements.postcode;
   const checked=postcode?info.postcode(postcode.value):null;
   if(checked&&!checked.valid)return;
   const intent=form.matches('[data-cpb-site-check]')?info.typeFor(form.elements.need?.value||type):type||'advice';
   info.fromTool(form,{id:source,source,type:intent,context:context||'business',summary:info.readable(result),postcode:checked?.postcode||''},mountAfter(result));
   if(context!=='home')window.CPAnalytics?.track?.('cp_planner_completed',{tool:source,context:context||'business'});
  });
 });
}
function init(scope=document){
 window.CPContextAdapters?.restore(scope);
 [...(scope.matches?.('[data-cp-bespoke]')?[scope]:[]),...scope.querySelectorAll('[data-cp-bespoke]')].forEach(root=>{
  [['[data-cpb-machine-router]','[data-cpb-machine-result]','Coffee machine route','advice'],['[data-cpb-site-check]','[data-cpb-site-result]','Site / service coverage','service'],['[data-cpb-hydration-tool] form','[data-cpb-hydration-result]','Workplace hydration estimate','advice'],['[data-cpb-coffee-demand-tool] form','[data-cpb-coffee-demand-result]','Office coffee demand','advice'],['[data-cpb-solution-tool] form','[data-cpb-solution-result]','Workplace drinks planner','advice'],['[data-cpb-install-tool] form','[data-cpb-install-result]','Installation readiness','installation']].forEach(([f,r,s,t])=>wire(root.querySelector(f),root.querySelector(r),s,t,'business',false));
 });
 [...(scope.matches?.('[data-cp-b2cx]')?[scope]:[]),...scope.querySelectorAll('[data-cp-b2cx]')].forEach(root=>{
  [['finder','Drink Finder'],['coffee','Coffee Match'],['setup','Home coffee setup'],['water','Home water check']].forEach(([id,label])=>wire(root.querySelector('[data-b2cx-'+id+']'),root.querySelector('[data-b2cx-'+id+'-result]'),label,id==='water'?'installation':'advice','home',true));
 });
}
window.CPEnquiryAdapters={init};
init();
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(),{once:true});
document.addEventListener('shopify:section:load',e=>init(e.target));
})();
